var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinksmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.48 1.52a2.92 2.92 0 0 0-4.13 0L4.71 3.16c.7-.13 1.44-.04 2.1.26l.72-.72A1.25 1.25 0 0 1 9.3 4.47l-.72.72-.48.48-.57.57a1.24 1.24 0 0 1-1.62.12l-.15-.12-.12-.15a.62.62 0 0 0-.73.11l-.72.73a2.9 2.9 0 0 0 4.52.49l.13-.13 1.64-1.64a2.92 2.92 0 0 0 0-4.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.19 8.58-.72.72A1.25 1.25 0 0 1 2.7 7.53l.72-.72.48-.48.57-.57a1.24 1.24 0 0 1 1.62-.12l.15.12.12.15c.24.12.53.08.73-.11l.72-.73A2.88 2.88 0 0 0 6.33 3.9a2.93 2.93 0 0 0-3.04.68l-.13.13-1.64 1.64a2.92 2.92 0 0 0 4.13 4.13l1.64-1.64c-.7.13-1.44.04-2.1-.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinksmall);
export default __webpack_public_path__ + "static/media/link.small.68c4c26fe0d470987a0f5b28ce24bebd.svg";
export { ForwardRef as ReactComponent };